import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const HeaderCell = ({ columnId, children, onSort, tooltipText, className, initialActive, tableClasses }) => {
  const [active, setActive] = useState(initialActive);
  const [direction, setDirection] = useState('desc');

  const onSortClick = () => {
    let newDirection = direction;
    let newActive = active;
    if (!active) {
      newActive = true;
      newDirection = 'desc';
    } else {
      if (direction === 'desc') {
        newDirection = 'asc';
      } else {
        newActive = false;
      }
    }
    setActive(newActive);
    setDirection(newDirection);
    onSort(columnId, newActive, newDirection);
  };

  return (
    <TableCell className={tableClasses}>
      {children && (
        <Tooltip title={tooltipText} placement="bottom-end" enterDelay={300}>
          {onSort ? (
            <TableSortLabel
              className={className}
              active={active}
              direction={direction}
              onClick={onSortClick}
              IconComponent={KeyboardArrowDownIcon}
            >
              {children}
            </TableSortLabel>
          ) : (
            <>{children}</>
          )}
        </Tooltip>
      )}
    </TableCell>
  );
};

HeaderCell.propTypes = {
  columnId: PropTypes.string,
  tooltipText: PropTypes.string,
  onSort: PropTypes.func,
  children: PropTypes.node,
  initialActive: PropTypes.bool,
  className: PropTypes.string,
  tableClasses: PropTypes.object
};

HeaderCell.defaultProps = {
  tooltipText: '',
  columnId: '',
  onSort: null,
  children: null,
  initialActive: false,
  className: null
};

export default HeaderCell;
